let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lBgV9")).then(() => parcelRequire('i6ZtS'));